export enum ConfiguratorInputActionsTypes {
  CONFIGURATOR_INPUT_READ = "@@CONFIGURATOR_INPUT read ",
  CONFIGURATOR_INPUT_READ_STATUS = "@@CONFIGURATOR_INPUT read  status"
}
